// extracted by mini-css-extract-plugin
module.exports = {"layout":"EssentialPricePlanDigitalTwin_layout__1JIbB","pricePlan":"EssentialPricePlanDigitalTwin_pricePlan__1jXhq"};